import {Component, OnInit, Input} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {HttpClient, HttpParams} from '@angular/common/http'
import {environment} from '../../../../environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {OAuthService} from '../../../services/oauth.service';
import {CookieService} from 'ngx-cookie';
import posthog from "posthog-js";
import {GlobalFlagsService} from "../../../services/global-flags.service";

@Component({
  selector: 'app-continue-with-sso',
  templateUrl: './continue-with-sso.component.html',
  styleUrls: ['./continue-with-sso.component.scss']
})
export class ContinueWithSSOComponent implements OnInit {

  logo = "menu_logo.png";
  errorOnLogin = false;

  messageError = null;

  isLoading = false;

  isButtonDisabled = false;

  dev = false;

  loggedInLocalhost = false;
  year= new Date().getFullYear();
  image1 = "/1.jpg";
  image2 = "/2.jpg";
  image3 = "/3.jpg";
  image4 = "/4.jpg";
  image5 = "/5.jpg";

  public href: string = "";

  readonly SSO_USERNAME_COOKIE: string = 'sso_username';

  @Input('input-email') username: string;


  constructor(
    private userService: UserService,
    private http: HttpClient,
    private dialog: MatDialog,
    private oauthService: OAuthService,
    private globalFlagsService: GlobalFlagsService,
    private cookieService: CookieService) {

  };

  ngOnInit(): void {
    this.isLoading = false;
    this.href = window.location.origin;
    this.dev = this.href.includes("dev");
    this.loggedInLocalhost = environment.url.api.includes("localhost");
    // Posthog logging for PROD. setPosthogEnabled true to work aftewrads.
    /*if(!this.globalFlagsService.isPosthogEnabled && environment.production){
      posthog.init(environment.posthog.token, environment.posthog.config);
      this.globalFlagsService.setPosthogEnabled(true);
    }
    else{
      this.globalFlagsService.setPosthogEnabled(false);
    }*/
    this.globalFlagsService.setPosthogEnabled(false);
  };

  continueWithSSO() {
    //From SSO login page we redirect to /api/user/continueWithSSO by pressing "Continue" button. We then set a cookie to compare usernames and the user gets redirected to it's respective SSO login url (okta, atrium, sharp).
    if (this.username != undefined) {
      this.isButtonDisabled = true;
      this.isLoading = true;
      this.username = this.username.toLowerCase();
      let prefix = `${environment.url.api}`;
      console.log(prefix);
      this.http.get(prefix + 'api/user/continueWithSSO', {
        responseType: 'text',
        params: new HttpParams().set('username', this.username)
      })
        .subscribe
        ((res) => {
            const object = JSON.parse(res);
            const ssoUrl = object.url;
            const ssoUsername = object.userId;
            const userHospital = object.userHospital;
            console.log(object);
            console.log(ssoUsername);
            console.log(ssoUrl);
            console.log(userHospital);
            let d = new Date();
            d.setDate(d.getDate() + 1);
            let web_domain_prefix = `${environment.url.web_domain}`;
            let options = {secure: true, expires: d, sameSite: "None", domain: web_domain_prefix};
            this.cookieService.put(this.SSO_USERNAME_COOKIE, this.username, options);
            // Check if posthog is enabled and send user id to be identified in posthog log server
            console.log("Is posthog enabled?: " + this.globalFlagsService.isPosthogEnabled);
            if (this.globalFlagsService.isPosthogEnabled) {
              posthog.identify(ssoUsername
                , {
                  provider: userHospital
                }
              );
            }
            window.location.href = ssoUrl;
          },
          (err) => {
            this.isLoading = false;
            this.errorOnLogin = true;
            this.messageError = 'An error has occurred.';
            this.isButtonDisabled = false;
          });
    } else {
      this.isLoading = false;
      this.isButtonDisabled = false;
      this.messageError = 'Please enter a valid username.';
      this.errorOnLogin = true;
    }
  }

}
